import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { ApiConstants } from './api.constants';
import { ToasterService } from 'angular2-toaster';

@Injectable()
export class CustomHttp {

    constructor(
        private router: Router,
        private http: Http, private apiConstants: ApiConstants, private toasterService: ToasterService) {
    }

    public getBaseUrl() {
        return this.apiConstants.HELPDESK_API_URL;
    }

    login(username: String, password: String) {
        const accountDetails = username + ':' + password;
        const encodedAccount = window.btoa(accountDetails);
        const headers = new Headers();
        headers.append('Authorization', 'Basic ' + encodedAccount);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.get(this.getBaseUrl() + '/authenticate', { headers: headers, body: '' })
            .map(response => {
                if (response.status === 200) {
                  //  console.log(response.headers.get('dataapi-user'));
                    localStorage.setItem('id_token', response.headers.get('X-AUTH-TOKEN'));
                    localStorage.setItem('is_data_api_user', response.headers.get('dataapi-user'));

                  //  console.log(response.headers);
                    this.router.navigate(['/search']);
                }
            }).toPromise().catch(this.handleError); // TODO: Display error message
    }

    get(uri: string, options?: RequestOptionsArgs) {
        options = this.addAuthorizationHeader(options);
        return this.http.get(this.getBaseUrl() + uri, options)
            .map(response => this.processResponse(response)).toPromise()
            .catch(error => this.handleError(error));
    }

    getText(uri: string, options?: RequestOptionsArgs) {
        options = this.addAuthorizationHeader(options);
        return this.http.get(this.getBaseUrl() + uri, options)
            .map(response => response.text()).toPromise()
            .catch(error => this.handleError(error));
    }

    post(uri: string, body: any, options?: RequestOptionsArgs) {
        options = this.addAuthorizationHeader(options);
        return this.http.post(this.getBaseUrl() + uri, body, options)
            .map(response => this.processResponse(response)).toPromise()
            .catch(error => this.handleError(error));

    }

    put(uri: string, body: any, options?: RequestOptionsArgs) {
        options = this.addAuthorizationHeader(options);
        return this.http.put(this.getBaseUrl() + uri, body, options)
            .map(response => this.processResponse(response)).toPromise()
            .catch(error => this.handleError(error));

    }

    delete(uri: string, body: any, options?: RequestOptionsArgs) {
        options = this.addAuthorizationHeader(options);
        return this.http.delete(this.getBaseUrl() + uri, options)
            .map(response => this.processResponse(response)).toPromise()
            .catch(error => this.handleError(error));
    }

    addAuthorizationHeader(options: RequestOptionsArgs) {

        if (typeof options === 'undefined') {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        options.headers.set('x-auth-token', localStorage.getItem('id_token'));
        options.headers.append('Content-Type', 'application/json');
        return options;
    }

    processResponse(response: Response) {
        if (response.headers) {
            if (response.headers.get('X-AUTH-TOKEN')) {
                localStorage.setItem('id_token', response.headers.get('X-AUTH-TOKEN'));
            }

            if (response.headers.get('DATAAPI-USER')) {
                localStorage.setItem('is_data_api_user', response.headers.get('DATAAPI-USER'));
            }
        }
        try {
            return response.json();
        } catch (error) {
            console.log(error);
        }
    }


    /*
    * This is the place for the dev use
    */
    putGTHisotrical(body: any, options?: RequestOptionsArgs): Observable<any> {
        options = this.addAuthorizationHeader(options);
        return this.http.put(`${this.apiConstants.GLOBAL_TREND_API_URL}/historical/`, body, options)
            .map(response => response)
            .catch(error => this.handleError(error));
    }

    putGTOverview(body: any, options?: RequestOptionsArgs): Observable<any> {
        options = this.addAuthorizationHeader(options);
        return this.http.put(`${this.apiConstants.GLOBAL_TREND_API_URL}/overview/`, body, options)
            .map(response => response)
            .catch(error => this.handleError(error));
    }

    getGeneType(body: any, options?: RequestOptionsArgs): Observable<any> {
        options = this.addAuthorizationHeader(options);
        return this.http.put(`${this.apiConstants.GLOBAL_TREND_API_URL}/genome/`, body, options)
            .map(response => response)
            .catch(error => this.handleError(error));
    }

    getGeneOptions(uri: string, options?: RequestOptionsArgs): Observable<any> {
        options = this.addAuthorizationHeader(options);
        return this.http.get(`${this.apiConstants.GLOBAL_TREND_API_URL}/badget_info/` + uri, options)
            .share()
            .map(response => response)
            .catch(error => this.handleError(error));
    }

    private handleError(error: any) {
        console.error('An error occurred', error);
        const jsonErrorBody = error._body ? JSON.parse(error._body) : undefined;
        if (error.status === 400) {
            //this.toasterService.pop('error', error.url, error.message || error.statusText);
            //}else if (error.status === 401) {
            //    this.router.navigate(['/login']);
        } else if (error.status === 500 || jsonErrorBody === undefined) {
            this.router.navigate(['/500']);
        }

        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom.http.ts